import React, {useCallback, useEffect, useRef, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {submitPremium} from "../api/RestCallHelper";
import DatePicker from "../shared/DatePicker";
import TextInput from "../shared/TextInput";
import {validateForm} from "../utils/ValidationUtil";
import FormPage from "./baseFormPage/BaseFormPage";
import FormHeader from "../shared/FormHeader";
import {FormButton} from "../styles/globalStyles";
import AutocompleteTextInput, {DataType} from "../shared/AutocompleteTextInput";
import {FeedbackReducerActionType, useFeedbackDispatch} from "../utils/FeedbackContext";
import useFetchMembersDropdown from "../hooks/useFetchMembersDropdown";
import ToggleButtonGroup from "../shared/ToggleButtonGroup";

export default () => {

  let location = useLocation();
  let history = useHistory();

  const dispatch = useFeedbackDispatch();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownData, loading] = useFetchMembersDropdown(dropdownOpen);

  const [premium, setPremium] = useState({
    amount:"",
    member:"",
    date:null,
    eft: true
  });

  const [formValidated, setFormValidated] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const isMounted = useRef(true);

  const clear = () => {
    setPremium({
        amount:"",
        member:"",
        date:null,
        eft: true
    });
  }

  const close = (event, reason) => {
    console.log("In ClaimsForm close callback");
    if (reason === 'clickaway') return;

    dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
  };

  const submit = useCallback(async () => {

    // don't send again while we are sending
    if (isSending) return;

    // update state
    setIsSending(true);

    // send the actual request
    await submitPremium(premium, dispatch, close, history, location);

    // once the request is sent, update state again
    if (isMounted.current){
      // only update if we are still mounted
      setIsSending(false);
      clear();
    }

  }, [isSending, location, isMounted, premium]); // update the callback if the state changes

  useEffect(() => {
    setFormValidated(validateForm(premium));
    console.log("premium", premium);
  }, [premium, formValidated]);

  return (

    <FormPage

      header = {
          <FormHeader
              heading= "Submit Premium"
          />
      }

      form = {
          <>
            <AutocompleteTextInput
              label = "Select Member"
              value = {premium.member}
              onChange = {(value) => setPremium({...premium , member: value})}
              optionsList = {dropdownData}
              loading = {loading}
              open = {dropdownOpen}
              setOpen = {setDropdownOpen}
              dataType = {DataType.MEMBER}
            />

            <DatePicker
                label="Date"
                value={premium.date}
                onChange={(value) => setPremium({ ...premium, date: value }) }
                style={{ margin: "10px" }}
            />

            <TextInput
              number
              label="Amount"
              value={premium.amount}
              onChange={(value) => setPremium({ ...premium, amount: value }) }
              style={{ margin: "10px" }}
            />

              <ToggleButtonGroup
                  value={premium.eft}
                  setValue= {(value) => (setPremium({...premium, eft: value}))}
                  trueOption="EFT"
                  falseOption="CASH"
              />

          </>
      }

      buttons = {
          <>
              {formValidated &&
                  <FormButton
                      disabled={isSending}
                      onClick={submit}
                  >
                      Submit
                  </FormButton>   
              }

              <FormButton
                  onClick={clear}
                  disabled={isSending}
              >
                  Clear
              </FormButton>
          </>
      }

    />
  );
}
